/* global angular, moment */
(function () {
  'use strict';
  angular.module('vcfinance.privcat')
    .component('privcatsearch', {
      restrict: 'E',
      bindings: {
        privcat: '<',
        privcatref: '<',
        editinplace: '@?',
        hideaddoption: '@?',
        onselectcb: '&?',
        ti: '@?'
      },
      template: `
        <div class="form-group">
          <div class="input-group">
                <input type="text" class="form-control" tabindex="{{vm.tabi}}"
                   ng-class="{'dirtyfield': vm.asyncSelected.length > 0}"
                   autofocus
                   placeholder="Kürzel"
                   ng-model="vm.asyncSelected"
                   typeahead-on-select="$parent.$dismiss();vm.showprivcat($item, $model, $label)"
                   uib-typeahead="privcat as privcat.text for privcat in vm.getPrivcats($viewValue)"
                   typeahead-loading="loadingNames"
                   typeahead-no-results="noResults">
            <span class="input-group-btn">
              <button type="submit"
                      ng-class="{'btn-warning': noResults, 'btn-info': !noResults}"
                      class="btn" tabindex="-1"><i class="fa fa-search"></i></button>
            </span>
          </div>
        </div>
        
        
        <i ng-show="loadingNames" class="fa fa-refresh"></i>
        <div ng-show="noResults">
          <i class="fa fa-warning"></i> Keine Privatleistungen gefunden
          <span class="btn btn-success" ng-click="vm.addPrivcat()" ng-hide="vm.error || vm.hideaddoption">Neue Privatleistung eingeben</span>
          <span ng-click="vm.addPrivcatEntry()" ng-show="vm.error"><i class="fa fa-warning text-danger"></i> Privatleistung konnte nicht angelegt werden!</span>
        </div>
        
        <div ng-show="vm.editinplace === true || vm.editinplace === 'true'">
          <span ng-show="vm.privcat.type==='entry'">
            <privcatentryeditor privcatentry="vm.privcat"></privcatentryeditor>
          </span>
          <span ng-show="vm.privcat.type==='group'">
            <privcatgroupeditor privcatgroup="vm.privcat"></privcatgroupeditor>
          </span>
        </div>
        
        
      `,
      controllerAs: 'vm',
      controller: ['$log', 'Privcat', 'PrivcatHelper',
        function ($log, Privcat, PrivcatHelper) {
          let vm = this;
          vm.save = save;
          vm.showprivcat = showprivcat;

          vm.getPrivcats = getPrivcats;
          vm.addPrivcatEntry = PrivcatHelper.addPrivcatEntry;
          vm.addPrivcatGroup = PrivcatHelper.addPrivcatGroup;
          vm.editPrivcatEntry = PrivcatHelper.editPrivcatEntry;
          vm.editPrivcatGroup = PrivcatHelper.editPrivcatGroup;

          vm.$onInit = function () {
            vm.newprivcat = {};


            if (angular.isDefined(vm.hideaddoption) && vm.hideaddoption === 'true') {
              vm.hideaddoption = true;
            }
            else {
              vm.hideaddoption = false;
            }


            if (angular.isUndefined(vm.ti)) {
              vm.ti = 0;
              vm.tabi = 0;
            }
            if (angular.isString(vm.ti)) {
              vm.tabi = parseInt(vm.ti, 10);
            }
            else {
              vm.tabi = 0;
            }
            vm.lastprivcat = angular.copy(vm.privcatresult);
            vm.lastprivcatref = angular.copy(vm.privcatref);
          };

          function addPrivcatEntry() {
            $log.debug('debug - privcatsearch addPrivcat called');
            PrivcatHelper.addPrivcat(function (privcat) {
              $log.debug('debug: handle newly create privcat');
              vm.privcat = {};
              vm.privcat.name = privcat.name;
              vm.privcat.short = privcat.short;
              vm.privcat._id = privcat._id;
              vm.privcatref = privcat._id;
              vm.asyncSelected = privcat.short;
              vm.parentsave({privcat: vm.privcat, privcatref: vm.privcatref});
            }, function (err) {
              vm.error = true;
              $log.error(err);
            });
          }


          // typeahead privcat search backend query
          function getPrivcats(val) {
            // return Privcatahead.$search({query: val}).$asPromise().then(function (response) {
            return Privcat.$searchahead({
              query: val,
              fields: ['shortcut', 'name']
            }).$asPromise().then(function (response) {
              return response.map(function (privcat) {
                if (privcat.type === 'entry') {
                  privcat.text = privcat.shortcut + ' - ' + privcat.name;
                } else {
                  privcat.text = 'Gruppe ' + privcat.shortcut + ' - ' + privcat.name;
                }

                delete vm.error;
                return privcat;
              });
            });
          }

          // typeahead privcat search action
          function showprivcat($item, $model, $label) {
            /* jshint unused:false */
            /* eslint "no-unused-lets": [2, {"args": "none"}] */
            vm.privcat = $model;
            vm.privcatref = $model._id;
            delete vm.asyncSelected;
            // $log.debug('debug showprivcat  - vm.editinplace, vm.editinplace === true?: ', vm.editinplace, vm.editinplace === true);
            if (vm.editinplace === true || vm.editinplace === 'true') {
              // $log.debug('edit inplace true path');
              vm.privcat = $model;
              vm.privcatref = $model._id;
              // $log.debug('debug - privcatsearch editinplace');
            }
            else {
              // $log.debug('edit inplace false path');

              vm.privcat = {};
              vm.privcat.name = $model.name;
              vm.privcat.short = $model.short;
              vm.privcat._id = $model._id;
              vm.privcat.type = $model.type;
              vm.privcat.active = $model.active;
              vm.privcatref = $model._id;
              if ($model.type = 'entry') {
                vm.privcat.details = $model.details;
                vm.privcat.price = $model.price;
                vm.privcat.tax = $model.tax;
                vm.privcat.repeatable = $model.repeatable;
                vm.privcat.svs = angular.copy($model.svs);
              }
              if ($model.type = 'group') {
                vm.privcat.items = angular.copy($model.items);

              }

              if (angular.isDefined(vm.onselectcb) && angular.isFunction(vm.onselectcb)) {
                vm.onselectcb({privcat: vm.privcat, privcatref: vm.privcatref});
              } else {
                $log.error('No privcat search callback provided');
              }

            }
          }

          function save() {
            if (!angular.equals(vm.privcat, vm.lastprivcat) || !angular.equals(vm.privcatref, vm.lastprivcatref)) {
              vm.lastprivcat = angular.copy(vm.privcat);
              vm.lastprivcatref = angular.copy(vm.privcatref);
              vm.parentsave({privcat: vm.privcat, privcatref: vm.privcatref});
            }
          }


        }] // controller
    }); // component

// klammerfriedhof
}());